export const params = {
    particles: {
        number: {
            value: 100,
            density: {
                enable: false,
            },
        },
        size: {
            value: 3,
            random: true,
            anim: {
                speed: 5,
                size_min: 0.3,
            },
        },
        line_linked: {
            enable: false,
        },
        move: {
            random: true,
            speed: 0.2,
            direction: "top",
            out_mode: "out",
        },
    },
};
